import { useUser } from "../../../../store/session/hooks";

import { GroupStudentContainer } from "../../../../components/groups/student/GroupStudentContainer";
import { useFocusedMeetingAPI, useMeetingSelector } from "../../../../hooks/meeting";
import { useStudentContext } from "../context";

export const MeetingGroupStudentPage = () => {
  const user = useUser();

  const studentCtx = useStudentContext();
  const meetingAPI = useFocusedMeetingAPI();
  const [meeting] = useMeetingSelector(meetingAPI, (state) => state.meeting);

  if (!studentCtx || !meeting || !user) {
    return null; // impossible
  }

  const { populatedMeetingData, currentView } = studentCtx;

  if (!populatedMeetingData || !currentView) {
    return null; // impossible
  }

  return (
    <GroupStudentContainer
      meeting={meeting}
      populatedMeeting={populatedMeetingData}
      view={currentView}
      selfUser={user}
      layout={studentCtx.layout}
      selfVideoStream={studentCtx.selfVideoStream}
    />
  );
}
